// // src/components/BrandDetails.js
// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { Box, Typography, CircularProgress } from '@mui/material';
// import API_ENDPOINTS from '../../apis/endpoints';

// const BrandDetails = () => {
//   const { brandId } = useParams();  // Get the brand ID from the URL
//   const [brand, setBrand] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchBrandDetails = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_ENDPOINTS.BRANDS}/${brandId}`, {
//           method: 'GET',
//           headers: {
//             'ngrok-skip-browser-warning': 'true',
//             'Content-Type': 'application/json',
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();
//         setBrand(data.data);
//       } catch (error) {
//         console.error('Error fetching brand details:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBrandDetails();
//   }, [brandId]);

//   return (
//     <Box padding={3}>
//       {loading ? (
//         <CircularProgress />
//       ) : (
//         brand && (
//           <>
//             <Typography variant="h4">{brand.brand}</Typography>
//             <Typography variant="subtitle1">Category: {brand.brand_category}</Typography>
//             <Typography variant="subtitle1">Sub Brand: {brand.sub_brand}</Typography>
//             <Typography variant="subtitle1">Revenue: {brand.revenue}</Typography>
//             <Typography variant="subtitle1">Deals: {brand.deals}</Typography>
//           </>
//         )
//       )}
//     </Box>
//   );
// };

// export default BrandDetails;
import React from 'react'

function BrandDetails() {
  return (
    <div>BrandDetails</div>
  )
}

export default BrandDetails